import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { GenericLinkModule, MediaModule, PageComponentModule } from '@spartacus/storefront';
import { CachedSrcDirective } from '../../../directives/CachedSrcDirective';
import { GgCookieConsentMessageComponent } from '../gg-cookie-consent/gg-cookie-consent-message/gg-cookie-consent-message.component';
import { GgMediaWithMobileMediaModule } from '../gg-media-with-mobile-media/gg-media-with-mobile-media.module';
import { InteractiveCarouselModule } from '../interactive-carousel/interactive-carousel.module';
import { GgMainIntroSliderItemComponent } from './gg-main-intro-slider-item/gg-main-intro-slider-item.component';
import { GgTransparentBoxComponent } from './gg-main-intro-slider-item/gg-transparent-box/gg-transparent-box.component';
import { GgMainIntroSliderVideoItemComponent } from './gg-main-intro-slider-video-item/gg-main-intro-slider-video-item.component';
import { GgMainIntroSliderComponent } from './gg-main-intro-slider.component';

@NgModule({
  declarations: [
    GgMainIntroSliderItemComponent,
    GgMainIntroSliderVideoItemComponent,
    GgTransparentBoxComponent,
  ],
  imports: [
    CommonModule,
    InteractiveCarouselModule,
    MediaModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GGMainIntroSliderComponent: { component: GgMainIntroSliderComponent },
        GGMainIntroSliderItemComponent: { component: GgMainIntroSliderItemComponent },
        GGMainIntroSliderVideoItemComponent: { component: GgMainIntroSliderVideoItemComponent },
        GGTransparentBoxComponent: { component: GgTransparentBoxComponent },
      },
    } as CmsConfig),
    PageComponentModule,
    GenericLinkModule,
    CachedSrcDirective,
    GgMediaWithMobileMediaModule,
    GgCookieConsentMessageComponent,
  ],
})
export class GgMainIntroSliderModule {}
